import type { AppData } from "../../types";
import { buildCustomerHistory } from "../../customer_history";
import { button, el, statusLabel } from "../atoms/dom";
import { duration, empty, initials, relativeDate } from "./dashboard_page";

export function customerDetailPage(
  data: AppData,
  customerId: string,
  actions: { onBack: () => void; onOpenAppointment: (id: string) => void },
) {
  const customer = data.customers.find((item) => item.id === customerId);
  if (!customer) {
    return el("div", { className: "page-stack" }, detailNav(actions.onBack), empty("Müşteri profili bulunamadı."));
  }
  const appointments = data.appointments
    .filter((item) => item.customerId === customer.id)
    .sort((a, b) => b.startsAt.localeCompare(a.startsAt));
  const calls = data.conversations
    .filter((item) => item.customerId === customer.id || item.callerPhoneNumber === customer.phoneNumber)
    .sort((a, b) => b.startedAt.localeCompare(a.startedAt));
  const history = buildCustomerHistory({
    customerId: customer.id,
    phoneNumber: customer.phoneNumber,
    appointments: data.appointments,
    conversations: data.conversations,
  });

  const historyRoot = el("div", { className: "history-list" });
  if (!history.length) {
    historyRoot.append(empty("Bu müşteri için henüz geçmiş işlem bulunmuyor."));
  } else {
    for (const item of history) {
      if (item.type === "appointment") {
        const appointment = item.appointment;
        const service = data.services.find((entry) => entry.id === appointment.serviceId);
        historyRoot.append(el(
          "button",
          { className: "history-item", attrs: { type: "button" }, onClick: () => actions.onOpenAppointment(appointment.id) },
          el("span", { className: "history-item__icon", text: "T" }),
          el("div", {}, el("strong", { text: service?.name ?? "Randevu" }), el("p", { text: relativeDate(appointment.startsAt) })),
          statusLabel(appointment.status),
        ));
      } else {
        const call = item.call;
        historyRoot.append(el(
          "article",
          { className: "history-item" },
          el("span", { className: "history-item__icon", text: "A" }),
          el("div", {}, el("strong", { text: "Telefon görüşmesi" }), el("p", { text: `${relativeDate(call.startedAt)} · ${duration(call.durationSeconds)}` }), el("span", { text: call.summary || "Görüşme özeti bulunmuyor." })),
          statusLabel(call.status),
        ));
      }
    }
  }

  return el(
    "div",
    { className: "page-stack" },
    detailNav(actions.onBack),
    el(
      "section",
      { className: "customer-profile-hero" },
      el("span", { className: "avatar avatar--xlarge", text: initials(customer.displayName) }),
      el("div", {}, el("span", { className: "eyebrow", text: "MÜŞTERİ / HASTA PROFİLİ" }), el("h2", { text: customer.displayName }), el("a", { text: customer.phoneNumber, attrs: { href: `tel:${customer.phoneNumber}` } })),
      el("div", { className: "customer-profile-hero__stats" }, metric(String(appointments.length), "Randevu"), metric(String(calls.length), "Görüşme")),
    ),
    el("section", { className: "panel" }, el("header", { className: "panel__header" }, el("h2", { text: "Geçmiş işlemler" }), el("span", { className: "muted", text: `${history.length} kayıt` })), historyRoot),
  );
}

function detailNav(onBack: () => void) {
  return el("div", { className: "detail-navigation" }, button("← Geri", onBack, "quiet"), el("strong", { text: "Müşteri profili" }));
}

function metric(value: string, label: string) {
  return el("span", {}, el("b", { text: value }), label);
}
